export const OLD_APPLIANCE_REMOVAL_SKU = '350099';
